import { connect } from 'react-redux';

import { getEventByHash } from 'actions/website/entities/EventActions';
import { getCurrentZoomEvent } from 'selectors/events/eventsSelectors';

import ZoomCreate from './ZoomCreate';

const mapState = (state, ownProps) => {
  const {
    params: { eventHash },
  } = ownProps;
  return {
    zoomEvent: getCurrentZoomEvent(state),
    eventHash,
  };
};

const mapDispatch = dispatch => ({
  fetchEventByHash: hash => dispatch(getEventByHash(hash)),
});

export default connect(mapState, mapDispatch)(ZoomCreate);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomCreate/index.js